import React from 'react';
import { Link } from 'react-router-dom';

import prodop01 from '../../assets/imgs/prodop/prodop01.png'; 
import prodop01_light from '../../assets/imgs/prodop/prodop01_light.png'; 
import prodop02 from '../../assets/imgs/prodop/prodop02.png'; 
import prodop_ui from '../../assets/imgs/prodop/prodop_UI.png'; 


import rtmicapital from '../../assets/imgs/rtmicapital/lion_loan.png'; 


const ProdopPage = () => {



  return (
              
        <div className='bg-light'>
          <div className='header-height'></div>
            <div className='row'>
              <div className='col-sm-2 col-xs-12'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row p-5'>
                  <div className='col-md text-start mb-5'>
                    <p className='fs-2 fw-normal capitalize mb-2'>Prodop</p>
                    {/* <p className='fs-1rem fw-light capitalize'>
                    Production managment platform
                    </p> */}
                    <p className='mt-3 fw-200'>2024</p>
                  </div>
                  <div className='col-md  mb-5'>
                    <p className='fw-300 fs-5'>
                    This work showcases a custom-built Production Management System for a creative agency, developed to streamline communication between clients and individuals creators, while documenting the production process and influence fast payment process for the work done.
                                        </p>
                  </div>



            </div>
          </div>

          <img className='img-fluid' src={prodop01} alt="Navina Risk 1" />





      <div className='row mx-0 p-5'>
        <div className='col-sm-6 col-xs-12 my-5 p-sm-5'>
          <p className='fs-5'>
          This work included the entire development of the system Prodop using React JS, AWS services, Adobe resources, and more to create a custom-built system that will help individual creators communicate better with our clients while also securing the payment process and the working hours spent on each item.
            </p>
            <br></br>
            <p className='fs-5'>
            The production of creative products often involves many iterations, feedback, unexpected extras, and term changes - which makes the individuals' work a headache.  Prodop allows you a better way to fully document and manage your work process.
            </p>
        </div>
          <div className='col-sm-6 col-xs-12'>
        </div>
        <div className='col-sm-9 col-xs-12'>
        <video width="100%" height="auto" loop autoPlay muted>
              <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/prodop-test.mp4" type="video/mp4" />
            </video>
        <img className='img-fluid py-4' src={prodop_ui} alt="Navina Risk 1" />
        <img className='img-fluid py-4' src={prodop02} alt="Navina Risk 1" />

        </div>
      </div>
    </div>



    <div className='row my-5'>
        <div className='col-sm-6 col-xs-12'></div>
          <div className='col-sm-6 col-xs-12 p-5'>
          <h6 className='my-4'>
            Design Overview
          </h6>
            <p className='fs-5'>
              This project served as a creative exploration into developing a realistic 3D look-and-feel within a digital product context. The primary design goal was to craft a visually immersive interface by integrating 3D aesthetics—balancing realism, clarity, and modern UI design.
            </p>
        </div>
      </div>
    <img className='img-fluid' src={prodop01_light} alt="Navina Risk 1" />



    <div className='row py-5 px-3 px-sm-5'>
      <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12'>

        <div className='py-2'>
          <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
              <h5 className='fs-18 fw-600'>Prodop</h5>
            </a>
        </div>


    <div className='row'>
      <div className='col-3'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
            <li className='py-1'>Animation</li>
            <li className='py-1'>3D Modeling</li>
            <li className='py-1'>UX/UI</li>
          </ul>
      </div>
      <div className='col-3'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Maya</li>
            <li className='py-1'>Substance Painter</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Photoshop</li>
            <li className='py-1'>Illustrator</li>
          </ul>
      </div>
      
    </div>
</div>
</div>

<div className='row mx-0 mt-5'>
  <div className='col-sm-12 col-xs-12 text-end p-5'>
      <Link to={"/rtmi-capital"}>
        <a className='fs-5 fw-bold text-dark'>
          Next work 
          <div className='arrow-right'></div>
          </a>
            </Link>
        </div>
        <div className='col-sm-2 col-xs-12 p-5'>

        </div>
          <div className='col-sm col-xs-12 p-0'>
          <Link to={"/rtmi-capital"}>
            <div className='image-box-300'>
              <img src={rtmicapital} alt="prodbo next" />
            </div>
          </Link>
        </div>
      </div>


</div>





  );
};

export default ProdopPage;
